import * as z from "zod";

// =============================================================================
// Dispute sources config (step: cb-dispute-sources)
// =============================================================================

const CbPaymentProvidersSchema_ = z.object({
  shopifyConnected: z.boolean().optional(),
  paypalConnected: z.boolean().optional(),
  stripeConnected: z.boolean().optional(),
  gorgiasConnected: z.boolean().optional(),
});
export const CbPaymentProvidersSchema: z.ZodType<CbPaymentProviders> =
  CbPaymentProvidersSchema_;
export interface CbPaymentProviders extends z.infer<
  typeof CbPaymentProvidersSchema_
> {}

// =============================================================================
// Evidence settings config (step: cb-evidence-settings)
// =============================================================================

const CbEvidenceSettingsSchema_ = z.object({
  automateEvidenceEnabled: z.boolean().optional(),
  evidenceWindowDays: z.number().int().min(5).max(30).optional(),
});
export const CbEvidenceSettingsSchema: z.ZodType<CbEvidenceSettings> =
  CbEvidenceSettingsSchema_;
export interface CbEvidenceSettings extends z.infer<
  typeof CbEvidenceSettingsSchema_
> {}

// =============================================================================
// Full completion payload (assembled by client, sent via completeOnboarding)
// =============================================================================

const ChargebacksCompletionPayloadSchema_ = z.object({
  evidenceSettings: CbEvidenceSettingsSchema,
});
export const ChargebacksCompletionPayloadSchema: z.ZodType<ChargebacksCompletionPayload> =
  ChargebacksCompletionPayloadSchema_;
export interface ChargebacksCompletionPayload extends z.infer<
  typeof ChargebacksCompletionPayloadSchema_
> {}

// =============================================================================
// Product availability (returned by getProgress, consumed by steps)
// =============================================================================

const ChargebacksAvailabilitySchema_ = z.object({
  hasDisputeScopes: z.boolean(),
  hasShopifyBilling: z.boolean(),
  disputesEnabled: z.boolean(),
  automateEvidenceEnabled: z.boolean(),
});
export const ChargebacksAvailabilitySchema: z.ZodType<ChargebacksAvailability> =
  ChargebacksAvailabilitySchema_;
export interface ChargebacksAvailability extends z.infer<
  typeof ChargebacksAvailabilitySchema_
> {}

// =============================================================================
// Default values (used by useStepFormData fallback)
// =============================================================================

export const DEFAULT_PAYMENT_PROVIDERS: CbPaymentProviders = {
  shopifyConnected: false,
  paypalConnected: false,
  stripeConnected: false,
  gorgiasConnected: false,
};

export const DEFAULT_EVIDENCE_SETTINGS: CbEvidenceSettings = {
  automateEvidenceEnabled: true,
  evidenceWindowDays: 5,
};
